import { useEffect, useState } from "react";
import { Link } from "wouter";
import { api } from "../lib/api";
import { useApp } from "../App";

type Tag = { name: string; category: string; n: number };

/** Taggregistret: håll ordförrådet rent – slå ihop dubbletter, sortera i kategorier. */
export function TagRegistry() {
  const { status } = useApp();
  const [tags, setTags] = useState<Tag[]>([]);
  const [filter, setFilter] = useState("");
  const load = () => api<Tag[]>("tags").then(setTags);
  useEffect(() => { load(); }, []);
  const cats = status?.categories ?? [];
  const shown = tags.filter((t) => t.name.includes(filter.toLowerCase()));
  const grouped = cats.map((c) => [c, shown.filter((t) => t.category === c)] as const).filter(([, l]) => l.length);

  const rename = async (t: Tag) => {
    const to = prompt(`Byt namn på ”${t.name}”. Finns namnet redan slås taggarna ihop.`, t.name);
    if (to && to !== t.name) { await api(`tags/${encodeURIComponent(t.name)}`, { method: "PATCH", json: { rename: to } }); load(); }
  };

  return (
    <div className="mx-auto max-w-5xl pt-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Taggar</h1>
          <p className="mt-1 text-soft">{tags.length} taggar. Byt namn för att rätta eller slå ihop, flytta mellan kategorier för bättre filter.</p>
        </div>
        <input className="field !w-64" placeholder="Filtrera…" value={filter} onChange={(e) => setFilter(e.target.value)} />
      </div>
      <div className="mt-6 space-y-6">
        {grouped.map(([c, list]) => (
          <section key={c}>
            <div className="h-section mb-2">{c}</div>
            <div className="card divide-y divide-line">
              {list.map((t) => (
                <div key={t.name} className="flex items-center gap-3 px-4 py-2">
                  <Link href={`/?tags=${encodeURIComponent(t.name)}`} className="flex-1 font-medium hover:text-ember">{t.name}</Link>
                  <span className="w-16 text-right text-muted tabular-nums">{t.n} bilder</span>
                  <select className="rounded-md border border-line bg-card px-2 py-1 text-[13px]" value={t.category}
                    onChange={async (e) => { await api(`tags/${encodeURIComponent(t.name)}`, { method: "PATCH", json: { category: e.target.value } }); load(); }}>
                    {cats.map((x) => <option key={x}>{x}</option>)}
                  </select>
                  <button className="text-[13px] text-soft hover:text-ink" onClick={() => rename(t)}>Byt namn</button>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
